import { useEffect, useState } from 'react'
import { Store } from 'app/redux/Store'
import useFeatureFlag from 'app/ducks/featureFlags/hooks'
import {
  getFeatureFlag,
  timestamp as featureFlagsTimestamp,
} from 'app/ducks/featureFlags/selectors'
import HttpHandler from 'app/reusable/HttpHandler'
import { RETENTION_MODULE_FLAG } from './constants'

export const useRetentionModule = () => useFeatureFlag(RETENTION_MODULE_FLAG)

// For route/nav `userCondition`s. Feature flags are cleared on every page load
// and re-fetched right after, so while they're pending this says "yes" and the
// page redirects to 404 itself once they resolve to off (same approach as the
// internal campaigns route).
export const retentionModuleUserCondition = () => {
  const state = Store.getState()
  return (
    !featureFlagsTimestamp(state) ||
    getFeatureFlag(state, RETENTION_MODULE_FLAG)
  )
}

// For menu entries: unlike the route, a menu entry only shows once the flag is
// known to be on, so it never flashes for tenants without the module.
export const isRetentionModuleEnabled = () =>
  !!getFeatureFlag(Store.getState(), RETENTION_MODULE_FLAG)

const useAllRecords = (app, model, filters, enabled = true) => {
  const [records, setRecords] = useState([])
  const [isLoading, setLoading] = useState(enabled)
  const filtersKey = JSON.stringify(filters)

  useEffect(() => {
    if (!enabled) return undefined
    let cancelled = false
    setLoading(true)
    HttpHandler.list(app, model, {
      paginate_by: 200,
      order_by: 'name',
      ...JSON.parse(filtersKey),
    })
      .then((response) => {
        if (!cancelled) setRecords(response?.data?.data || [])
      })
      .catch(() => {
        if (!cancelled) setRecords([])
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })
    return () => {
      cancelled = true
    }
  }, [app, model, filtersKey, enabled])

  return { records, isLoading }
}

export const useCancellationReasons = ({ onlyActive = true, enabled } = {}) =>
  useAllRecords(
    'contracts',
    'cancellation-reason',
    onlyActive ? { status: 'active' } : {},
    enabled
  )

export const useUserTags = ({ enabled } = {}) =>
  useAllRecords('users', 'user-tag', {}, enabled)
